import "./loadingFS.css";
import { useWeb } from "../../../hooks";
import { Spin } from "antd";
import { useEffect } from "react";

const LoadingFS: React.FC = () => {
  const { loading } = useWeb();

  useEffect(() => {
    if (loading.isLoading) {
      // Bloquea el scroll
      document.body.style.overflow = "hidden";
    } else {
      // Restaura el scroll
      document.body.style.overflow = "";
    }

    // Limpieza por si el componente se desmonta mientras está bloqueado
    return () => {
      document.body.style.overflow = "";
    };
  }, [loading.isLoading]);

  return (
    <>
      <div className={`loadingFS-container ${loading.isLoading ? "show" : ""}`}>
        <Spin size="large" />

        <p className="loadingFS-text">{loading.text}</p>
      </div>
    </>
  );
};

export default LoadingFS;
